import { render, staticRenderFns } from "./shareshop1.vue?vue&type=template&id=b53d5d06&scoped=true&"
import script from "./shareshop1.vue?vue&type=script&lang=js&"
export * from "./shareshop1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53d5d06",
  null
  
)

export default component.exports